import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import StampingAnomaliesPage from '@/routes/hours/anomalies/stampings/StampingAnomaliesPage'
import { getPreviousMonth, toApiDate } from '@/routes/hours/anomalies/anomalies.utils'
import { RoleRoute } from '@/types'
import { faFingerprint } from '@fortawesome/free-solid-svg-icons'
import { AxiosResponse } from 'axios'
import { defer, LoaderFunction } from 'react-router-typesafe'

export interface GetIrregularStamping {
  user: { id: number; email: string; fullName: string }
  day: string
  issue: string
  type: string
}

export const getIrregularStampings = (from: Date, to: Date) =>
  useQsAdminApiManager
    .getState()
    .client.get<
      GetIrregularStamping[]
    >(`api/attivitaLavorativa/irregularstampings?from=${toApiDate(from)}&to=${toApiDate(to)}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    })

export const stampingAnomaliesPageRouteLoader = (async () => {
  const [minDate, maxDate] = getPreviousMonth()
  const getIrregularsStamping: Promise<AxiosResponse<GetIrregularStamping[], GetIrregularStamping[]>> =
    getIrregularStampings(minDate, maxDate)
  return defer({
    getIrregularsStamping,
    minDate,
    maxDate,
  })
}) satisfies LoaderFunction

export const StampingAnomaliesPageRoute = {
  path: 'stampings',
  element: <StampingAnomaliesPage />,
  loader: stampingAnomaliesPageRouteLoader,
  errorElement: <RouterErrorHandler />,
  text: 'Accessi',
  faIcon: faFingerprint,
  handle: {
    crumb: () => ({
      label: 'Accessi',
    }),
  },
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
} satisfies RoleRoute
